export const LS_SESSION_ID = 'session_id';

export class NoSessionIdError extends Error {}
export class FinishedSessionError extends Error {}
export class EntryNotExists extends Error {}
